/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { createRoot } from "react-dom/client";
import { App } from "./App";
import { appConfig } from "./utils/config";

function resolveConfigUrl(): string {
  try {
    return process.env.BUN_PUBLIC_CONFIG_URL ?? "/config";
  } catch {
    return "/config";
  }
}

async function start() {
  const configUrl = resolveConfigUrl();
  try {
    await appConfig.mergeFromUrl(configUrl);
  } catch (e) {
    console.error(`Failed to load external config from ${configUrl}:`, e);
  }

  const root = createRoot(document.getElementById("root")!);
  root.render(<App />);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
